import { render, staticRenderFns } from "./CsDocuments.vue?vue&type=template&id=48a42f4a&scoped=true&"
import script from "./CsDocuments.vue?vue&type=script&lang=js&"
export * from "./CsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CsDocuments.vue?vue&type=style&index=0&id=48a42f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a42f4a",
  null
  
)

export default component.exports